import { createLabeledMessages } from '../../../messageUtils';
const help = {
    onlineChat: 'Online chat',
    shareScreen: 'Sdílet obrazovku',
    help: 'Pomoc',
    dialogTitle: 'Zahájení sdílení obrazovky',
    dialogEndRelation: 'Ukončit relaci',
    dialogNeedHelp: 'Potřebujete pomoci prostřednictvím sdílení obrazovky?',
    dialogContact: 'Kontaktujte nás telefonicky na podpůrné lince',
    dialogShareToOperator: 'Vygenerovaný PIN sdělte operátorovi'
};
const messages = Object.assign({}, help);
export default Object.assign({}, messages, createLabeledMessages(messages));
